/* Jawahir Al-Khair theme JS — AJAX cart drawer (ported from the SABEH theme engine) */
(function () {
  'use strict';

  const body = document.body;
  const drawer = () => document.getElementById('CartDrawer');

  let _currency = 'USD';
  function fmtMoney(cents) {
    const amount = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: _currency, currencyDisplay: 'narrowSymbol' }).format(amount);
    } catch (e) {
      return amount.toLocaleString() + ' ' + _currency;
    }
  }

  function openCart() { body.classList.add('cart-open'); drawer()?.setAttribute('aria-hidden', 'false'); }
  function closeCart() { body.classList.remove('cart-open'); drawer()?.setAttribute('aria-hidden', 'true'); }

  async function refreshCart(openAfter) {
    try {
      const cart = await (await fetch('/cart.js')).json();
      updateCounts(cart);
      await jakGoalsUpdate(cart);
      await rerenderDrawer();
      if (openAfter) openCart();
    } catch (e) { console.warn('Jawahir Al-Khair cart refresh failed', e); }
  }

  function updateCounts(cart) {
    if (cart && cart.currency) _currency = cart.currency;
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('[data-cart-drawer-count]').forEach(el => {
      el.textContent = cart.item_count;
    });
    document.querySelectorAll('[data-cart-total]').forEach(el => {
      el.textContent = fmtMoney(cart.total_price);
    });
    const foot = document.querySelector('[data-cart-foot]');
    if (foot) foot.hidden = cart.item_count === 0;
    const sgbCart = document.getElementById('sgb-cart');
    if (sgbCart) sgbCart.hidden = cart.item_count === 0;
    renderCartDiscounts(cart);
  }

  function renderCartDiscounts(cart) {
    const drawerEl = drawer();
    if (!drawerEl) return;
    let container = drawerEl.querySelector('.cart-discounts');
    const apps = (cart.cart_level_discount_applications || []);

    let hasShipping = false;
    let rowsHtml = '';
    apps.forEach(app => {
      if (app.target_type === 'shipping_line') { hasShipping = true; return; }
      rowsHtml += '<div class="cart-discount-row"><span class="cart-discount-row__label">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 4.5 4.5L19 7"/></svg>' +
        ' كود خصم مُطبّق: <span class="cart-discount-row__code">' + (app.title || '') + '</span></span>' +
        (cart.total_discount > 0 ? '<span class="cart-discount-row__amount lat">-' + fmtMoney(cart.total_discount) + '</span>' : '') +
        '</div>';
    });
    if (hasShipping) {
      rowsHtml += '<span class="cart-freeship-badge"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6h11v9H2zM13 9h4l3 3v3h-7z"/><circle cx="6" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg> شحن مجاني مُفعّل 🎉</span>';
    }

    if (!rowsHtml) {
      if (container) container.remove();
      return;
    }
    if (!container) {
      container = document.createElement('div');
      container.className = 'cart-discounts';
      container.style.padding = '12px 22px 0';
      const head = drawerEl.querySelector('.cart-drawer__head');
      if (head) head.insertAdjacentElement('afterend', container);
      else drawerEl.prepend(container);
    }
    container.innerHTML = rowsHtml;
  }

  async function rerenderDrawer() {
    try {
      const res = await fetch('/?section_id=cart-drawer-items');
      if (res.ok) {
        const html = await res.text();
        const container = document.querySelector('[data-cart-items]');
        if (container && html.trim()) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-cart-items]') || doc.body;
          container.innerHTML = fresh.innerHTML || container.innerHTML;
        }
      }
    } catch (e) { /* items will refresh on next load */ }
  }

  async function addToCart(variantId, qty) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    });
    await refreshCart(true);
  }

  async function changeLine(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    await refreshCart(false);
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openCart(); return; }

    const closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn) { e.preventDefault(); closeCart(); return; }

    const add = e.target.closest('[data-add-variant]');
    if (add) {
      e.preventDefault();
      const id = add.dataset.addVariant;
      if (id) addToCart(id, 1);
      return;
    }

    const vopen = e.target.closest('[data-variant-open]');
    if (vopen) { e.preventDefault(); openVariant(vopen.dataset.productHandle); return; }
    if (e.target.closest('[data-variant-close]')) { e.preventDefault(); closeVariant(); return; }
    const vopt = e.target.closest('[data-vm-opt]');
    if (vopt && !vopt.disabled && vmState) {
      vmState.sel[+vopt.dataset.vmOpt] = vopt.dataset.vmVal;
      renderVariantOptions();
      return;
    }
    const vadd = e.target.closest('[data-vm-add]');
    if (vadd) {
      const id = vadd.dataset.vmVariant;
      if (id) { addToCart(id, 1); closeVariant(); }
      return;
    }

    const up = e.target.closest('[data-qty-up]');
    if (up) { const line = up.closest('[data-line-key]'); bump(line, +1); return; }
    const down = e.target.closest('[data-qty-down]');
    if (down) { const line = down.closest('[data-line-key]'); bump(line, -1); return; }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { changeLine(rm.dataset.lineRemove, 0); return; }
  });

  function bump(lineEl, delta) {
    if (!lineEl) return;
    const key = lineEl.dataset.lineKey;
    // Read the quantity from the dedicated data-qty-num element/attribute —
    // NOT from '.lat' (that class is shared with the price span, which used
    // to be matched first and caused quantity to jump to price+1).
    const qtyEl = lineEl.querySelector('[data-qty-num]') || lineEl.querySelector('.cart-line__qty');
    let current = 1;
    if (qtyEl) {
      const attr = qtyEl.getAttribute('data-qty-num');
      const raw = (attr != null ? attr : qtyEl.textContent || '1').trim();
      const normalized = raw.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
      const parsed = parseInt(normalized, 10);
      if (!isNaN(parsed)) current = parsed;
    }
    changeLine(key, Math.max(0, current + delta));
  }

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeCart(); closeVariant(); } });

  const vmodal = () => document.getElementById('VariantModal');
  let vmState = null;

  function openVariant(handle) {
    const data = document.querySelector('script[data-variant-data="' + CSS.escape(handle) + '"]');
    if (!data) return;
    let json;
    try { json = JSON.parse(data.textContent); } catch (e) { return; }
    const m = vmodal();
    if (!m) return;

    const thumb = m.querySelector('[data-vm-thumb]');
    if (json.image) {
      thumb.innerHTML = '<div class="ph" style="aspect-ratio:1/1;border-radius:var(--r-sm);background:' + (json.swatch || '#B8860B') + ';"><img src="' + json.image + '" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:var(--r-sm);"></div>';
    } else {
      thumb.innerHTML = '<div class="ph" style="aspect-ratio:1/1;border-radius:var(--r-sm);background:radial-gradient(120% 100% at 30% 18%, rgba(255,255,255,.34), transparent 60%),' + (json.swatch || '#B8860B') + ';"></div>';
    }
    m.querySelector('[data-vm-title]').textContent = json.title;

    const sel = json.options.map(o => o.values[0]);
    vmState = { json, sel };
    renderVariantOptions();
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    body.classList.add('modal-open');
  }

  function renderVariantOptions() {
    const m = vmodal(); if (!m || !vmState) return;
    const { json, sel } = vmState;
    const wrap = m.querySelector('[data-vm-options]');
    wrap.innerHTML = json.options.map((opt, oi) => {
      const btns = opt.values.map(val => {
        const active = sel[oi] === val;
        const ok = json.variants.some(v => v.available && v.options[oi] === val);
        return '<button type="button" class="vopt' + (active ? ' is-active' : '') + '"' + (ok ? '' : ' disabled') +
          ' data-vm-opt="' + oi + '" data-vm-val="' + val.replace(/"/g, '&quot;') + '">' + val + '</button>';
      }).join('');
      return '<div class="vmodal__group"><h4>' + opt.name + '</h4><div class="vmodal__opts">' + btns + '</div></div>';
    }).join('');
    updateVariantCta();
  }

  function currentVariant() {
    if (!vmState) return null;
    const { json, sel } = vmState;
    return json.variants.find(v => v.options.every((o, i) => o === sel[i])) || null;
  }

  function updateVariantCta() {
    const m = vmodal(); if (!m || !vmState) return;
    const btn = m.querySelector('[data-vm-add]');
    const v = currentVariant();
    if (v && v.available) {
      btn.disabled = false; btn.style.opacity = '1'; btn.style.cursor = 'pointer';
      btn.innerHTML = 'أضف للسلة · <span class="lat">' + v.price + '</span>';
      btn.dataset.vmVariant = v.id;
    } else {
      btn.disabled = true; btn.style.opacity = '.5'; btn.style.cursor = 'not-allowed';
      btn.innerHTML = v ? 'غير متاح حاليًا' : 'اختر النوع';
      btn.dataset.vmVariant = '';
    }
  }

  function closeVariant() {
    const m = vmodal();
    if (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }
    body.classList.remove('modal-open');
    vmState = null;
  }

  function initHeroSliders() {
    document.querySelectorAll('[data-hero-slider]').forEach(root => {
      const slides = [...root.querySelectorAll('[data-hero-slide]')];
      const dots = [...root.querySelectorAll('[data-hero-dot]')];
      if (slides.length > 1) {
        let i = 0;
        const show = (n) => {
          i = (n + slides.length) % slides.length;
          slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
          dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
        };
        let timer = setInterval(() => show(i + 1), 5500);
        const reset = () => { clearInterval(timer); timer = setInterval(() => show(i + 1), 5500); };
        root.querySelector('[data-hero-next]')?.addEventListener('click', () => { show(i + 1); reset(); });
        root.querySelector('[data-hero-prev]')?.addEventListener('click', () => { show(i - 1); reset(); });
        dots.forEach((d, k) => d.addEventListener('click', () => { show(k); reset(); }));
      }
      const reviews = [...root.querySelectorAll('[data-review-item]')];
      const rdots = [...root.querySelectorAll('[data-review-dot]')];
      if (reviews.length > 1) {
        let r = 0;
        const showR = (n) => {
          r = (n + reviews.length) % reviews.length;
          reviews.forEach((it, k) => it.style.display = k === r ? 'block' : 'none');
          rdots.forEach((d, k) => d.classList.toggle('is-active', k === r));
        };
        setInterval(() => showR(r + 1), 6500);
        rdots.forEach((d, k) => d.addEventListener('click', () => showR(k)));
      }
    });
  }
  if (document.readyState !== 'loading') initHeroSliders();
  else document.addEventListener('DOMContentLoaded', initHeroSliders);

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action$="/cart/add"], #product-form');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = fd.get('id');
    const qty = parseInt(fd.get('quantity')) || 1;
    if (id) addToCart(id, qty);
  });

  async function initGoals() {
    if (!window.jakGoals || !window.jakGoals.length) return;
    try {
      const cart = await (await fetch('/cart.js')).json();
      if (cart && cart.currency) _currency = cart.currency;
      jakGoalsUpdate(cart);
    } catch (e) { /* silent */ }
  }

  function getGoalLabel(goal) {
    if (goal.label) return goal.label;
    if (goal.type === 'free_shipping') return 'شحن مجاني 🚚';
    if (goal.type === 'free_product') return (goal.productTitle || 'منتج مجاني') + ' 🎁';
    if (goal.type === 'cashback') return 'خصم ' + goal.cashbackPct + '% 💰';
    return 'مكافأة';
  }

  function formatPrice(cents) {
    return fmtMoney(cents);
  }

  async function jakGoalsUpdate(cart) {
    const goals = window.jakGoals;
    if (!goals || !goals.length) return;

    const total = cart.total_price;
    const max   = window.jakGoalsMax || goals[goals.length - 1].target;

    const pct  = Math.min(100, (total / max) * 100);
    const fill = document.getElementById('sgb-fill');
    if (fill) {
      fill.style.width = pct + '%';
      fill.setAttribute('aria-valuenow', Math.round(total / 100));
    }

    document.querySelectorAll('[data-sgb-marker]').forEach(marker => {
      const target = parseInt(marker.dataset.sgbTarget || '0');
      marker.classList.toggle('is-achieved', total >= target);
    });

    const nextGoal = goals.find(g => total < g.target);
    const msgEl   = document.getElementById('sgb-msg');
    if (msgEl) {
      if (!nextGoal) {
        msgEl.textContent = '🎉 لقد حصلت على جميع المكافآت!';
      } else {
        const remaining = formatPrice(nextGoal.target - total);
        let msg = '';
        if (nextGoal.type === 'free_shipping') {
          msg = 'فاضلك ' + remaining + ' كمان والتوصيل يبقي مجاني';
        } else if (nextGoal.type === 'free_product') {
          msg = 'فاضل؛ ' + remaining + ' كمان وتاخد ' + (nextGoal.productTitle || 'منتج مجاني') + ' هدية';
        } else if (nextGoal.type === 'cashback') {
          msg = 'فاضلك ' + remaining + ' ويبقي ليك ' + nextGoal.cashbackPct + '% كاش باك على الاوردر الجي';
        }
        msgEl.textContent = msg;
      }
    }

    renderCartGoals(cart);

    await syncFreeShipping(cart);

    await syncRewardProducts(cart);
  }

  const JAK_FREE_SHIP_BUNDLE_TITLES = [
    'عرض ٣ كيلو تمر مجدول فاخر + توصيل مجاني'
  ];

  function jakCartHasFreeShipBundle(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      const title = ((item.product_title || item.title || '') + '').trim();
      return JAK_FREE_SHIP_BUNDLE_TITLES.indexOf(title) !== -1;
    });
  }

  function renderCartGoals(cart) {
    const goals = window.jakGoals;
    const container = document.getElementById('sgb-cart');
    if (!container || !goals || !goals.length) return;

    const total = cart.total_price;
    const max   = window.jakGoalsMax || goals[goals.length - 1].target;
    const pct   = Math.min(100, (total / max) * 100);

    const icons = { free_shipping: '🚚', free_product: '🎁', cashback: '💰' };

    // If the cart already contains a product that bundles free delivery on
    // its own (e.g. the "3kg + free delivery" offer), the free-shipping
    // progress nudge is redundant here — drop it from consideration.
    const hasFreeShipBundle = jakCartHasFreeShipBundle(cart);
    const goalsForDisplay   = hasFreeShipBundle
      ? goals.filter(g => g.type !== 'free_shipping')
      : goals;

    if (hasFreeShipBundle && !goalsForDisplay.length) {
      container.innerHTML = '';
      container.hidden = true;
      return;
    }
    container.hidden = false;

    const nextGoalObj = goalsForDisplay.find((g, i) => total < g.target);
    const lastAchieved = [...goals].reverse().find(g => total >= g.target);
    const displayGoal  = nextGoalObj || null;

    let milestonesHtml = '';

    if (!displayGoal) {
      milestonesHtml = '<div class="sgb-cart__milestone is-achieved">' +
        '<span class="sgb-cart__milestone-icon">🎉</span>' +
        '<span class="sgb-cart__milestone-label">لقد حصلت على جميع المكافآت!</span>' +
        '</div>';
    } else {
      const g         = displayGoal;
      const targetFmt = (g.target / 100).toLocaleString('ar-EG');
      const remaining = formatPrice(g.target - total);

      let rowLabel = '';
      if (g.type === 'free_shipping') {
        rowLabel = 'فاضلك ' + remaining + ' كمان والتوصيل يبقي مجاني';
      } else if (g.type === 'free_product') {
        rowLabel = 'فاضل؛ ' + remaining + ' كمان وتاخد ' + (g.productTitle || 'منتج مجاني') + ' هدية';
      } else if (g.type === 'cashback') {
        rowLabel = 'فاضلك ' + remaining + ' ويبقي ليك ' + g.cashbackPct + '% كاش باك على الاوردر الجي';
      }

      milestonesHtml = '<div class="sgb-cart__milestone is-next">' +
        '<span class="sgb-cart__milestone-icon">' + (icons[g.type] || '🎁') + '</span>' +
        '<span class="sgb-cart__milestone-label">' + rowLabel + '</span>' +
        '</div>';

      if (lastAchieved && lastAchieved.type === 'cashback' && lastAchieved.promoCode) {
        const safeCode = lastAchieved.promoCode.replace(/'/g, "\\'");
        milestonesHtml += '<div class="sgb-cart__milestone is-achieved" style="margin-top:6px;">' +
          '<span class="sgb-cart__milestone-icon">💰</span>' +
          '<span class="sgb-cart__milestone-label">كودك: ' +
            '<button type="button" class="sgb-promo" onclick="navigator.clipboard&&navigator.clipboard.writeText(\'' +
            safeCode + '\').then(()=>{var c=this.querySelector(\'.sgb-promo__copy\');c.textContent=\'تم النسخ ✓\';setTimeout(()=>{c.textContent=\'انسخ\';},2000);})" aria-label="انسخ كود الخصم">' +
            '<span>' + lastAchieved.promoCode + '</span>' +
            '<span class="sgb-promo__copy">انسخ</span>' +
            '</button>' +
          '</span>' +
          '</div>';
      }
    }

    container.innerHTML =
      '<div class="sgb-cart__bar">' +
        '<div class="sgb__rail"></div>' +
        '<div class="sgb__fill" style="width:' + pct + '%"></div>' +
        goals.map(g => {
          const mp = Math.min(100, (g.target / max) * 100);
          const achieved = total >= g.target;
          return '<div class="sgb__marker' + (achieved ? ' is-achieved' : '') +
            '" style="left:' + mp + '%;">' +
            '<span class="sgb__marker-icon">' + (icons[g.type] || '🎁') + '</span>' +
            '<div class="sgb__marker-dot"></div>' +
            '</div>';
        }).join('') +
      '</div>' +
      '<div class="sgb-cart__milestones">' + milestonesHtml + '</div>';
  }

  let _lastShippingState = null;

  async function syncFreeShipping(cart) {
    const goals = window.jakGoals;
    if (!goals) return;

    const shippingGoal = goals.find(g => g.type === 'free_shipping');
    if (!shippingGoal) return;

    const code      = window.jakShippingCode || 'FreeDelivery';
    const achieved  = cart.total_price >= shippingGoal.target;
    const nextState = achieved ? 'applied' : 'removed';

    if (nextState === _lastShippingState) return;
    _lastShippingState = nextState;

    try {
      if (achieved) {
        await fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' });
      } else {
        await fetch('/discount/remove', { method: 'GET', credentials: 'same-origin' });
      }
      const fresh = await (await fetch('/cart.js')).json();
      if (fresh && fresh.currency) _currency = fresh.currency;
      renderCartDiscounts(fresh);
    } catch (e) { /* silent — network error won't break the cart */ }
  }

  let _rewardSyncing = false;
  async function syncRewardProducts(cart) {
    const goals = window.jakGoals;
    if (!goals || _rewardSyncing) return;
    const freeProductGoals = goals.filter(g => g.type === 'free_product' && (g.freeVariantId || g.productVariant));
    if (!freeProductGoals.length) return;

    _rewardSyncing = true;
    try {
      for (const goal of freeProductGoals) {
        const variantId  = goal.freeVariantId || goal.productVariant;
        const achieved   = cart.total_price >= goal.target;
        const rewardItems = cart.items.filter(item =>
          item.properties && String(item.properties['_jak_reward']) === String(goal.target)
        );
        const alreadyAdded = rewardItems.length > 0;

        if (achieved && !alreadyAdded) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1,
                properties: {
                  '_jak_reward': String(goal.target),
                  '_reward_label': goal.productTitle || 'هدية مجانية'
                }
              }]
            })
          });
          const fresh = await (await fetch('/cart.js')).json();
          updateCounts(fresh);
          renderCartGoals(fresh);
          await rerenderDrawer();

        } else if (!achieved && alreadyAdded) {
          for (const item of rewardItems) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
          }
          const fresh = await (await fetch('/cart.js')).json();
          updateCounts(fresh);
          renderCartGoals(fresh);
          await rerenderDrawer();
        }
      }
    } catch (e) { /* silent */ }
    _rewardSyncing = false;
  }

  if (document.readyState !== 'loading') initGoals();
  else document.addEventListener('DOMContentLoaded', initGoals);

  function updateCornerTop() {
    const stack = document.querySelector('.sticky-top');
    if (!stack) return;
    const h = stack.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--sticky-top-h', (h + 10) + 'px');
  }
  if (document.readyState !== 'loading') updateCornerTop();
  else document.addEventListener('DOMContentLoaded', updateCornerTop);
  window.addEventListener('resize', updateCornerTop);

})();